import logoImage from "../../assest/images/logo-img.png"
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png"
import backgroundImg from "../../assest/images/securitybg4.jpg"
import { Link } from "react-router-dom"
import LastBox from "../../components/LastBox"
import ProviderList from "../../components/ProviderList"
import helper from "../../common/Helper"

const Index = ({ verify, state, changeValue, handlePaste, handlePasteButtonClick, canResend, timer, resendOtp,formatTime }) => {
    const { otp, error } = state;

    return (
        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Security Verification Requirements
                    </h1>
                    <form onSubmit={verify}>
                        <div className="sq-input-wrap getOtpBox">
                            <label className="sq-label" htmlFor="sq-otp">We have sent the verification code to your email
</label>
                            <div style={{position:"relative"}}>
                                <input id="sq-otp" className="sq-input no-icon" name="otp" type="text" value={otp} placeholder="" onChange={changeValue} onPaste={handlePaste} maxLength="6" required />
                                <a className="comYellowa" href="javascript:void(0)" onClick={(e) => handlePasteButtonClick(e)}>PASTE</a>
                                {error && error.otp && <span className="cus-err login-err">{error.otp}</span>}
                            </div>
                        </div>
                    </form>
                    <div className="sq-divider">OR</div>

                    <p className="sq-signup-link">Did not receive the code?&nbsp;
                            {canResend ? (
                            <a href="javascript:void(0)" onClick={() => resendOtp()}>Resend</a>
                        ) : (
                            <span className="disabled">&nbsp;Resend in {formatTime(timer)}</span>
                        )}
                    </p>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )

}
export default Index;